import { useI18n } from '@affine/i18n';
import type { ReactNode } from 'react';
import { useId, useState } from 'react';

import * as styles from './styles.css';

export function PreviewImpactCard({
  title,
  subtitle,
  children,
  wide = false,
  defaultOpen = true,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  children: ReactNode;
  wide?: boolean;
  defaultOpen?: boolean;
}) {
  const t = useI18n();
  const bodyId = useId();
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const canReveal = !defaultOpen;
  const isClipped = canReveal && !isOpen;
  const cardClassName = [
    styles.importImpactCard,
    wide ? styles.importImpactCardWide : null,
  ]
    .filter(Boolean)
    .join(' ');
  const bodyClassName = [
    styles.importImpactBody,
    isClipped ? styles.importImpactBodyClipped : null,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <section className={cardClassName}>
      <div className={styles.importImpactHeader}>
        <div>
          <h3 className={styles.importImpactTitle}>{title}</h3>
          {subtitle ? (
            <p className={styles.importImpactSubtitle}>{subtitle}</p>
          ) : null}
        </div>
      </div>
      <div id={bodyId} className={bodyClassName}>
        {children}
      </div>
      {canReveal ? (
        <button
          type="button"
          className={styles.importImpactRevealButton}
          aria-expanded={isOpen}
          aria-controls={bodyId}
          onClick={() => setIsOpen(open => !open)}
        >
          {isOpen
            ? t['com.streamlain.marketplace.import.show-less']()
            : t['com.streamlain.marketplace.import.show-more']()}
          <span className={styles.importImpactRevealIcon} aria-hidden>
            {'›'}
          </span>
        </button>
      ) : null}
    </section>
  );
}
